import React from 'react';

const UsedPhoneSalePricePage = React.lazy(() => import('pages/UsedPhoneSalePrice/pages/UsedPhoneSalePricePage'));

const usedPhoneSalePriceRoute = [
  {
    path: '/used-phone-sale-price',
    exact: true,
    name: 'Giá bán máy cũ',
    function: 'ST_PRICEIMEICODE_VIEW',
    component: UsedPhoneSalePricePage,
  },
];

export default usedPhoneSalePriceRoute;
